import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  startLoading,
  stopLoading,
  startFormLoading,
  stopFormLoading,
} from './loader';
import { setValidation } from './validation';
import { store } from '..';
import { selectEasyWalkThroughFormData } from '../selectors/easyWalkThroughForm';
import { setEasyWalkThroughFormData } from './easyWalkThroughForm';
import moment from 'moment';
import { clearServiceRequestByGroup } from '../actions/serviceRequestsByGroup';
export const fetchServiceRequestsDone = (payload) => ({
  type: TYPES.FETCH_SERVICE_REQUESTS_DONE,
  payload,
});
export const fetchReportsDone = (payload) => ({
  type: TYPES.FETCH_REPORTS_DONE,
  payload,
});
export const clearReports = () => ({
  type: TYPES.CLEAR_REPORTS_DONE,
});
export const fetchServiceRequestsSearchDone = (payload) => ({
  type: TYPES.FETCH_SERVICE_REQUESTS_SEARCH_DONE,
  payload,
});
export const fetchCustomerFeedReportsDone = (payload) => ({
  type: TYPES.FETCH_CUSTOMER_FEEDBACK_DONE,
  payload,
});

export const fetchServiceRequestByPropertyIdUserIdRole =
  (propertyId, userId, role, count, text, search) => (dispatch) => {
    if (count === 1) {
      dispatch(clearPaginationCount());
      if (search === true) {
      } else {
        dispatch(clearServiceRequests());
        dispatch(startLoading());
      }
      dispatch(clearPageCount());
    }

    return client
      .getServiceRequestByPropertyIdUserIdRole(
        propertyId,
        userId,
        role,
        count,
        text
      )
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            dispatch(stopLoading());
            if (search === true) {
              dispatch(
                fetchServiceRequestsSearchDone(
                  responsejson.serviceRequestsList.results
                )
              );
            } else {
              dispatch(
                fetchServiceRequestsDone(
                  responsejson.serviceRequestsList.results
                )
              );
            }
            dispatch(savePaginationCount(count));
            dispatch(savePageCount(responsejson.serviceRequestsList.pageCount));
          });
        } else {
          dispatch(stopLoading());
        }
      });
  };

export const fetchServiceRequestByCommonAreaIdUserIdRole =
  (propertyId, role, count, text, search) => (dispatch) => {
    if (count === 1) {
      dispatch(clearPaginationCount());
      if (search === true) {
      } else {
        dispatch(clearServiceRequests());
        dispatch(startLoading());
      }
      dispatch(clearPageCount());
    }
    return client
      .getServiceRequestByCommonIdUserIdRole(propertyId, role, count, text)
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            dispatch(stopLoading());
            if (search === true) {
              dispatch(
                fetchServiceRequestsSearchDone(
                  responsejson.serviceRequestsList.results
                )
              );
            } else {
              dispatch(
                fetchServiceRequestsDone(
                  responsejson.serviceRequestsList.results
                )
              );
            }
            dispatch(savePaginationCount(count));
            dispatch(savePageCount(responsejson.serviceRequestsList.pageCount));
          });
        } else {
          dispatch(stopLoading());
        }
      });
  };

const deleteServiceRequestDone = (payload) => ({
  type: TYPES.DELETE_SERVICE_REQUEST_DONE,
  payload,
});

export const deleteServiceRequest =
  (id, history, walkthroughId) => (dispatch) => {
    return client.deleteServiceRequest(id).then((response) => {
      if (response.ok || response.status === 204) {
        response.json().then((responsejson) => {});
        dispatch(deleteServiceRequestDone(id));
        toast.success(' ⓘ The service request has been deleted.', {
          autoClose: 10000,
          position: 'top-center',
        });
        if (history === 'walkthrough') {
          const easyWalkThroughFormData = selectEasyWalkThroughFormData(
            store.getState()
          );
          let filterList =
            easyWalkThroughFormData.walkThroughServiceRequests.filter(
              (data) => data.id !== id
            );
          dispatch(
            setEasyWalkThroughFormData({
              walkThroughServiceRequests: filterList,
            })
          );
        } else {
          history.push('/app/service-requests');
        }
      } else {
        toast.error(
          ' 🚫 Something went wrong with deleting the service request, please try again.',
          { autoClose: 12000, position: 'top-center' }
        );
      }
    });
  };

export const clearServiceRequests = () => ({
  type: TYPES.CLEAR_SERVICE_REQUESTS_DONE,
});

export const fetchLatestServiceRequests = (id) => (dispatch) => {
  return client.fetchLatestServiceRequests(id).then((response) => {
    if (response.ok || response.status === 200) {
      response
        .json()
        .then((responsejson) =>
          dispatch(fetchServiceRequestsDone(responsejson))
        );
    }
  });
};

export const fetchServiceRequestsListByUser =
  (id, role, count, text, search) => (dispatch) => {
    if (count === 1) {
      dispatch(clearPaginationCount());
      if (search === true) {
      } else {
        dispatch(clearServiceRequests());
        dispatch(startLoading());
      }
      dispatch(clearPageCount());
    }
    const userDetails = JSON.parse(localStorage.getItem('user'));
    let loginUserId = null,
      loginUserRole = null;
    if (!!userDetails) {
      loginUserId = userDetails.id;
      loginUserRole = userDetails.roles[0].role.name;
    }
    return client
      .fetchServiceRequestsListByUser(
        id,
        role,
        loginUserId,
        loginUserRole,
        count,
        text
      )
      .then((response) => {
        if (response.status === 200 || response.ok) {
          response.json().then((responsejson) => {
            dispatch(stopLoading());
            if (search === true) {
              dispatch(
                fetchServiceRequestsSearchDone(
                  responsejson.serviceRequestsList.results
                )
              );
            } else {
              dispatch(
                fetchServiceRequestsDone(
                  responsejson.serviceRequestsList.results
                )
              );
            }
            dispatch(savePaginationCount(count));
            dispatch(savePageCount(responsejson.serviceRequestsList.pageCount));
          });
        } else {
          dispatch(stopLoading());
        }
      });
  };

export const savePaginationCount = (payload) => ({
  type: TYPES.SERVICE_REQUEST_PAGINATION,
  payload,
});

export const clearPaginationCount = (payload) => ({
  type: TYPES.CLEAR_PAGINATION_COUNT,
  payload,
});

export const fetchOverviewStatusAndDays = (payload) => ({
  type: TYPES.FETCH_OVER_VIEW_STATUS_DAYS_DONE,
  payload,
});

export const savePageCount = (payload) => ({
  type: TYPES.SERVICE_REQUEST_PAGE_COUNT,
  payload,
});

export const clearPageCount = (payload) => ({
  type: TYPES.CLEAR_PAGE_COUNT,
  payload,
});
export const fetchfilteredServiceRequestByStatusAndDays =
  (
    id,
    role,
    status,
    days,
    count,
    text,
    search,
    filterValues,
    isCallingCountApi
  ) =>
  (dispatch) => {
    dispatch(startFormLoading());
    if (count === 1) {
      dispatch(clearPaginationCount());
      if (search === true) {
      } else {
        dispatch(clearServiceRequests());
        dispatch(startLoading());
      }
      dispatch(clearPageCount());
    }
    let params = '';
    if (filterValues?.startDate) params += `/${filterValues.startDate}`;
    else params += '/ ';
    if (filterValues?.endDate) params += `/${filterValues.endDate}`;
    else params += '/ ';
    if (filterValues?.project) params += `/${filterValues.project}`;
    else params += '/ ';
    if (filterValues?.suite && filterValues?.suite.length > 0) {
      let suite = filterValues?.suite;
      const ids = suite.map(({ Id }) => Id).join('&');
      params += `/${ids}`;
    } else {
      params += '/ ';
    }
    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0) {
      let withoutWarrantyIssueStatus = filterValues.walkthrough.filter(
        (data) =>
          data !== 'One Year Warranty Issue' &&
          data !== 'Internal' &&
          data !== 'Homeowner or Occupant' &&
          data !== 'Group'
      );
      params +=
        withoutWarrantyIssueStatus.length > 0
          ? `/${withoutWarrantyIssueStatus}`
          : '/ ';
    } else {
      params += '/ ';
    }
    if (filterValues?.issueType) params += `/${filterValues.issueType}`;
    else params += '/ ';
    if (filterValues?.assetType) params += `/${filterValues.assetType}`;
    else params += '/ ';
    if (filterValues?.building) params += `/${filterValues.building}`;
    else params += '/ ';
    if (filterValues?.level) params += `/${filterValues.level}`;
    else params += '/ ';
    if (filterValues?.assignTo) params += `/${filterValues.assignTo}`;
    else params += '/ ';
    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0) {
      let withWarrantyIssueStatus = filterValues.walkthrough.filter(
        (data) => data === 'One Year Warranty Issue'
      );
      params += withWarrantyIssueStatus.length > 0 ? `/${true}` : '/ ';
    } else {
      params += '/ ';
    }

    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0) {
      let internal = filterValues.walkthrough.filter(
        (data) => data === 'Internal'
      );
      let homeOwnerOrOccupant = filterValues.walkthrough.filter(
        (data) => data === 'Homeowner or Occupant'
      );
      if (internal.length > 0 || homeOwnerOrOccupant.length > 0) {
        if (internal.length > 0 && homeOwnerOrOccupant.length > 0) {
          params += `/Internal,Homeowner or Occupant`;
        } else if (internal.length > 0) {
          params += `/Internal`;
        } else if (homeOwnerOrOccupant.length > 0) {
          params += `/Homeowner or Occupant`;
        }
      } else {
        params += '/ ';
      }
    } else {
      params += '/ ';
    }

    params += `/${store.getState().serviceRequestsByGroup.displayClosedAndResolvedTickets}`;

    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0) {
      let withWarrantyIssueStatus = filterValues.walkthrough.filter(
        (data) => data === 'Group'
      );
      params += withWarrantyIssueStatus.length > 0 ? `/${true}` : '/ ';
    } else {
      params += '/ ';
    }
    if (filterValues?.commonAreas) params += `/${filterValues.commonAreas}`;
    else params += '/ ';

    if (filterValues?.tags && filterValues?.tags.length > 0) {
      let tags = filterValues?.tags;
      const ids = tags.map(({ value }) => value).join('&');
      params += `/${ids}`;
    } else {
      params += '/ ';
    }

    if (text) params += `/${text}`;
    else params += '/ ';
    return client
      .fetchfilteredServiceRequestByStatusAndDays(
        id,
        role,
        status,
        days,
        count,
        text,
        params
      )
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            dispatch(setValidation('Done'));
            if (search === true) {
              dispatch(
                fetchServiceRequestsSearchDone(
                  responsejson.serviceRequestsList.results
                )
              );
            } else {
              dispatch(
                fetchServiceRequestsDone(
                  responsejson.serviceRequestsList.results
                )
              );
            }
            if (
              isCallingCountApi !== undefined &&
              isCallingCountApi !== null &&
              isCallingCountApi !== '' &&
              isCallingCountApi === true
            ) {
              client
                .fetchfilteredServiceRequestByStatusCount(
                  id,
                  role,
                  'default',
                  days,
                  count,
                  text,
                  params
                )
                .then((response) => {
                  if (response.ok || response.status) {
                    response.json().then((responsejson) => {
                      dispatch(fetchOverviewStatusAndDays(responsejson));
                    });
                  }
                });
            }
            dispatch(savePaginationCount(count));
            dispatch(savePageCount(responsejson.serviceRequestsList.pageCount));
            if (count === 1) dispatch(stopLoading());
            dispatch(stopFormLoading());
          });
        }
      });
  };

export const updateServiceRequestsStatusDone = (payload) => ({
  type: TYPES.UPDATE_SERVICE_REQUEST_STATUS_DONE,
  payload,
});

export const archiveServiceRequest = (payload) => ({
  type: TYPES.ARCHIVE_SERVICE_REQUESTS_DONE,
  payload,
});

export const updateBulkStatus = (params, role, params1, from) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .updateBulkStatus(params)
    .then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            if (params.name === 'Archive') {
              dispatch(archiveServiceRequest(params));
            } else {
              dispatch(updateServiceRequestsStatusDone(params));
            }
            if (from === 'dashboard') {
              dispatch(
                fetchfilteredServiceRequestByStatusAndDays(
                  params1.userID,
                  params1.role,
                  params1.status,
                  params1.cdays,
                  params1.count,
                  params1.text,
                  params1.search,
                  params1.filterValues
                )
              );
            } else if (from === 'serviceRequest') {
              window.history.back();
            } else if (from === 'Property') {
              dispatch(
                fetchServiceRequestByPropertyIdUserIdRole(
                  params.propertyId,
                  params1.userID,
                  role,
                  1,
                  ''
                )
              );
            }
            dispatch(stopFormLoading());
            toast.success(' ⓘ The service requests status has been updated.', {
              autoClose: 5000,
              position: 'top-center',
            });
          } else {
            dispatch(stopFormLoading());
            toast.error(
              ' 🚫 Something went wrong with updating a service requests status, please try again.',
              { autoClose: 5000, position: 'top-center' }
            );
          }
        });
      } else {
        toast.error(
          ' 🚫 Something went wrong with updating a service requests status, please try again.',
          { autoClose: 5000, position: 'top-center' }
        );
        dispatch(stopFormLoading());
      }
    })
    .catch(() => {
      toast.error(
        ' 🚫 Something went wrong with updating a service requests status, please try again.',
        { autoClose: 5000, position: 'top-center' }
      );
      dispatch(stopFormLoading());
    });
};

export const createServiceRequestByGroup = (params, params1) => (dispatch) => {
  dispatch(startFormLoading());
  return client
    .createServiceRequestByGroup(params)
    .then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            dispatch(clearServiceRequestByGroup());
            dispatch(stopFormLoading());
            toast.success(' ⓘ Service Request group has been created.', {
              autoClose: 5000,
              position: 'top-center',
            });
          } else {
            dispatch(stopFormLoading());
            toast.error(` 🚫 ${responsejson.message}`, {
              autoClose: 5000,
              position: 'top-center',
            });
          }
        });
      } else {
        toast.error(
          ' 🚫 Something went wrong with creation of service requests group, please try again.',
          { autoClose: 5000, position: 'top-center' }
        );
        dispatch(stopFormLoading());
      }
    })
    .catch(() => {
      toast.error(
        ' 🚫 Something went wrong with creation of service requests group, please try again.',
        { autoClose: 5000, position: 'top-center' }
      );
      dispatch(stopFormLoading());
    });
};

export const fetchGroupServiceRequest =
  (groupId, id, role, status, days, count, text, search, filterValues) =>
  (dispatch) => {
    dispatch(startFormLoading());
    let params = '';
    if (filterValues?.startDate) params += `/${filterValues.startDate}`;
    else params += '/ ';
    if (filterValues?.endDate) params += `/${filterValues.endDate}`;
    else params += '/ ';
    if (filterValues?.project) params += `/${filterValues.project}`;
    else params += '/ ';
    if (filterValues?.suite && filterValues?.suite.length > 0) {
      let suite = filterValues?.suite;
      const ids = suite.map(({ Id }) => Id).join('&');
      params += `/${ids}`;
    } else {
      params += '/ ';
    }
    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0) {
      let withoutWarrantyIssueStatus = filterValues.walkthrough.filter(
        (data) =>
          data !== 'One Year Warranty Issue' &&
          data !== 'Internal' &&
          data !== 'Homeowner or Occupant' &&
          data !== 'Group'
      );
      params +=
        withoutWarrantyIssueStatus.length > 0
          ? `/${withoutWarrantyIssueStatus}`
          : '/ ';
    } else {
      params += '/ ';
    }
    if (filterValues?.issueType) params += `/${filterValues.issueType}`;
    else params += '/ ';
    if (filterValues?.assetType) params += `/${filterValues.assetType}`;
    else params += '/ ';
    if (filterValues?.building) params += `/${filterValues.building}`;
    else params += '/ ';
    if (filterValues?.level) params += `/${filterValues.level}`;
    else params += '/ ';
    if (filterValues?.assignTo) params += `/${filterValues.assignTo}`;
    else params += '/ ';
    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0) {
      let withWarrantyIssueStatus = filterValues.walkthrough.filter(
        (data) => data === 'One Year Warranty Issue'
      );
      params += withWarrantyIssueStatus.length > 0 ? `/${true}` : '/ ';
    } else {
      params += '/ ';
    }

    if (filterValues?.walkthrough && filterValues?.walkthrough.length > 0) {
      let internal = filterValues.walkthrough.filter(
        (data) => data === 'Internal'
      );
      let homeOwnerOrOccupant = filterValues.walkthrough.filter(
        (data) => data === 'Homeowner or Occupant'
      );
      if (internal.length > 0 || homeOwnerOrOccupant.length > 0) {
        if (internal.length > 0 && homeOwnerOrOccupant.length > 0) {
          params += `/Internal,Homeowner or Occupant`;
        } else if (internal.length > 0) {
          params += `/Internal`;
        } else if (homeOwnerOrOccupant.length > 0) {
          params += `/Homeowner or Occupant`;
        }
      } else {
        params += '/ ';
      }
    } else {
      params += '/ ';
    }

    params += `/${store.getState().serviceRequestsByGroup.displayClosedAndResolvedTickets}`;
    if (filterValues?.commonAreas) params += `/${filterValues.commonAreas}`;
    else params += '/ ';

    if (filterValues?.tags && filterValues?.tags.length > 0) {
      let tags = filterValues?.tags;
      const ids = tags.map(({ value }) => value).join('&');
      params += `/${ids}`;
    } else {
      params += '/ ';
    }

    if (text) params += `/${text}`;
    else params += '/ ';

    return client
      .fetchGroupServiceRequest(groupId, id, role, status, days, params)
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            dispatch(
              fetchServiceRequestsByGroupDone({
                id: groupId,
                response: responsejson,
              })
            );
          });
          dispatch(stopFormLoading());
        }
      });
  };

export const fetchServiceRequestsByGroupDone = (payload) => ({
  type: TYPES.SAVE_SERVICE_REQUEST_BY_GROUP,
  payload,
});

export const fetchReports = (params) => (dispatch) => {
  dispatch(startLoading());
  return client
    .fetchReports(params)
    .then((response) => {
      dispatch(stopLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.length > 0) {
          } else {
            toast.success('No reports found.', {
              autoClose: 5000,
              position: 'top-center',
            });
          }
          dispatch(fetchReportsDone(responsejson));
        });
      } else {
        dispatch(fetchReportsDone([]));
      }
    })
    .catch(() => {
      dispatch(stopLoading());
      toast.error(' 🚫 Something went wrong, please try again.', {
        autoClose: 5000,
        position: 'top-center',
      });
    });
};

export const fetchUserActivityReport = (params) => (dispatch) => {
  dispatch(startLoading());
  return client
    .fetchUserActivityReport(params)
    .then((response) => {
      dispatch(stopLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.length > 0) {
            let res = responsejson.map((re) => {
              return {
                ...re,
                time: moment(re.date).format('hh:mm A'),
                date: moment(re.date).format('dddd MM/DD/YYYY'),
              };
            });
            dispatch(fetchReportsDone(res));
          } else {
            toast.success('No reports found.', {
              autoClose: 5000,
              position: 'top-center',
            });
            dispatch(fetchReportsDone([]));
          }
        });
      } else {
        dispatch(fetchReportsDone([]));
      }
    })
    .catch(() => {
      dispatch(stopLoading());
      toast.error(' 🚫 Something went wrong, please try again.', {
        autoClose: 5000,
        position: 'top-center',
      });
    });
};

export const fetchUserStatusReports = (propertyIds) => (dispatch) => {
  dispatch(startLoading());
  return client
    .fetchUserStatusReports(propertyIds)
    .then((response) => {
      dispatch(stopLoading());
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson && responsejson.length > 0) {
            dispatch(fetchReportsDone(responsejson));
          } else {
            toast.success('No reports found.', {
              autoClose: 5000,
              position: 'top-center',
            });
            dispatch(fetchReportsDone([]));
          }
        });
      } else {
        dispatch(fetchReportsDone([]));
      }
    })
    .catch(() => {
      dispatch(stopLoading());
      toast.error(' 🚫 Something went wrong, please try again.', {
        autoClose: 5000,
        position: 'top-center',
      });
    });
};

export const fetchCustomerFeedback = (params) => async (dispatch) => {
  dispatch(startLoading());
  try {
    const response = await client.fetchCustomerFeedback(params);
    dispatch(stopLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        if (responsejson && responsejson.length > 0) {
        } else {
          toast.success('No reports found.', {
            autoClose: 5000,
            position: 'top-center',
          });
        }
        dispatch(fetchCustomerFeedReportsDone(responsejson));
      });
    } else {
      dispatch(fetchCustomerFeedReportsDone([]));
    }
  } catch {
    dispatch(stopLoading());
    toast.error(' 🚫 Something went wrong, please try again.', {
      autoClose: 5000,
      position: 'top-center',
    });
  }
};

export const fetchSuiteServiceRequests =
  (id, role, count, text, search) => (dispatch) => {
    if (count === 1) {
      dispatch(clearPaginationCount());
      if (search === true) {
      } else {
        dispatch(clearServiceRequests());
        dispatch(startLoading());
      }
      dispatch(clearPageCount());
    }

    return client
      .getSuiteServiceRequests(id, role, count, text)
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            dispatch(stopLoading());
            if (search === true) {
              dispatch(
                fetchServiceRequestsSearchDone(
                  responsejson.serviceRequestsList.results
                )
              );
            } else {
              dispatch(
                fetchServiceRequestsDone(
                  responsejson.serviceRequestsList.results
                )
              );
            }
            dispatch(savePaginationCount(count));
            dispatch(savePageCount(responsejson.serviceRequestsList.pageCount));
          });
        } else {
          dispatch(stopLoading());
        }
      });
  };

export const fetchServiceRequestByItemId =
  (itemId, userId, role, count, text, search) => (dispatch) => {
    if (count === 1) {
      dispatch(clearPaginationCount());
      if (search === true) {
      } else {
        dispatch(clearServiceRequests());
        dispatch(startLoading());
      }
      dispatch(clearPageCount());
    }

    return client
      .fetchServiceRequestByItemId(itemId, userId, role, count, text)
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            dispatch(stopLoading());
            if (search === true) {
              dispatch(
                fetchServiceRequestsSearchDone(
                  responsejson.serviceRequestsList.results
                )
              );
            } else {
              dispatch(
                fetchServiceRequestsDone(
                  responsejson.serviceRequestsList.results
                )
              );
            }
            dispatch(savePaginationCount(count));
            dispatch(savePageCount(responsejson.serviceRequestsList.pageCount));
          });
        } else {
          dispatch(stopLoading());
        }
      });
  };
